import {
  WEIGHT_FETCH,
  WEIGHT_FETCH_TYPE,
  WEIGHT_ADD,
  WEIGHT_ADD_LITTER_MEMBER,
  WEIGHT_UPDATE,
  WEIGHT_UPDATE_LITTER_MEMBER,
  WEIGHT_DELETE,
  WEIGHT_DELETE_LITTER_MEMBER,
  AUTH_LOG_OUT_USER,
  TRANSFERS_UPDATE_PET_AND_TRANSFER,
} from "actions/types";
import { AUTH_LOG_OUT_PROVIDER } from "containers/auth/Pet_Services_Portal/actions";
import _ from "lodash";

const INITIAL_STATE = {
  entries: [],
  fetchType: "",
  fetchDates: "",
  lastFetchPetID: "",
};

export default function WeightReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case WEIGHT_FETCH:
      return {
        ...state,
        entries: _.sortBy(action.payload, "date").reverse(),
        lastFetchPetID: action.pet._id,
      };
    case WEIGHT_FETCH_TYPE:
      return {
        ...state,
        fetchDates: action.payload.dates,
        fetchType: action.payload.type,
      };
    case WEIGHT_ADD:
    case WEIGHT_ADD_LITTER_MEMBER:
      return {
        ...state,
        entries: _.sortBy([...state.entries, action.payload], "date").reverse(),
        fetchDates: "",
      };
    case WEIGHT_UPDATE:
    case WEIGHT_UPDATE_LITTER_MEMBER:
      return {
        ...state,
        entries: _.sortBy(
          [
            ...state.entries.filter(
              (entry) => entry._id !== action.payload._id
            ),
            action.payload,
          ],
          "date"
        ).reverse(),
      };
    case WEIGHT_DELETE:
    case WEIGHT_DELETE_LITTER_MEMBER:
      return {
        ...state,
        entries: state.entries.filter((entry) => entry._id !== action.payload),
      };
    case TRANSFERS_UPDATE_PET_AND_TRANSFER:
    case AUTH_LOG_OUT_USER:
    case AUTH_LOG_OUT_PROVIDER:
      return INITIAL_STATE;
    default:
      return state;
  }
}
